import { useAuthContext } from '../context';
import { roleOf } from '../../../shared/utils/roles';

/** The signed-in user's "role.level" (e.g. 'admin.tenant'), or null. */
export const useCurrentRole = (): string | null => roleOf(useAuthContext().user);
